export const ThemesAI = [
    'Артикли',
    'Present Simple',
    'Past Simple',
    'Future Simple',
    'Present Continuous',
    'Past Continuous',
    'Future Continuous',
    'Present Perfect',
    'Past Perfect',
    'Future Perfect',
    'Present Perfect Continuous',
    'Past Perfect Continuous',
    'Базовая структура предложений',
    'Модальные глаголы'
];